import Repository from "./Repository";

const GET_PODCAST = "/podcast/get";
const GET_ALL_PODCAST = "/podcast/getall";
const CREATE_PODCAST = "/podcast/create";
const UPDATE_PODCAST = "/podcast/update";
const DELETE_PODCAST = "/podcast/delete";

const GET_CATEGORY = "/podcast_category/get";
const GET_ALL_CATEGORY = "/podcast_category/getall";
const CREATE_CATEGORY = "/podcast_category/create";
const UPDATE_CATEGORY = "/podcast_category/update";
const DELETE_CATEGORY = "/podcast_category/delete";

const GET_EPISODE = "/podcast_episode/get";
const GET_ALL_EPISODE = "/podcast_episode/getall";
const CREATE_EPISODE = "/podcast_episode/create";
const UPDATE_EPISODE = "/podcast_episode/update";
const DELETE_EPISODE = "/podcast_episode/delete";

const GET_ALL_HISTORY = "/watchHistory/getall";
const CREATE_HISTORY = "/watchHistory/create";
const UPDATE_HISTORY = "/watchHistory/update";

const GET_ALL_FORM = "/form/getall";
const CREATE_FORM = "/form/create";
const UPDATE_FORM = "/form/update";
const DELETE_FORM = "/form/delete";

export default {
  get_podcast(payload) {
    return Repository.get(transformRoute(GET_PODCAST), { params: payload });
  },
  getall_podcast(payload) {
    return Repository.get(transformRoute(GET_ALL_PODCAST), {
      params: payload,
    });
  },
  add_podcast(payload) {
    return Repository.post(transformRoute(CREATE_PODCAST), payload);
  },
  update_podcast(payload) {
    return Repository.post(transformRoute(UPDATE_PODCAST), payload);
  },
  delete_podcast(payload) {
    return Repository.post(transformRoute(DELETE_PODCAST), payload);
  },

  //---Podcast Category----//
  get_category(payload) {
    return Repository.get(transformRoute(GET_CATEGORY), { params: payload });
  },
  getall_category(payload) {
    return Repository.get(transformRoute(GET_ALL_CATEGORY), {
      params: payload,
    });
  },
  add_category(payload) {
    return Repository.post(transformRoute(CREATE_CATEGORY), payload);
  },
  update_category(payload) {
    return Repository.post(transformRoute(UPDATE_CATEGORY), payload);
  },
  delete_category(payload) {
    return Repository.post(transformRoute(DELETE_CATEGORY), payload);
  },

  //---Podcast Episode----//
  get_episode(payload) {
    return Repository.get(transformRoute(GET_EPISODE), { params: payload });
  },
  getall_episode(payload) {
    return Repository.get(transformRoute(GET_ALL_EPISODE), {
      params: payload,
    });
  },
  add_episode(payload) {
    return Repository.post(transformRoute(CREATE_EPISODE), payload);
  },
  update_episode(payload) {
    return Repository.post(transformRoute(UPDATE_EPISODE), payload);
  },
  delete_episode(payload) {
    return Repository.post(transformRoute(DELETE_EPISODE), payload);
  },

  //-------//
  getall_history(payload) {
    return Repository.get(transformRoute(GET_ALL_HISTORY), {
      params: payload,
    });
  },
  add_history(payload) {
    return Repository.post(transformRoute(CREATE_HISTORY), payload);
  },
  update_history(payload) {
    return Repository.post(transformRoute(UPDATE_HISTORY), payload);
  },

  // //-------//
  // getall_form(payload) {
  //   return Repository.get(transformRoute(GET_ALL_FORM), {
  //     params: payload,
  //   });
  // },
  // add_form(payload) {
  //   return Repository.post(transformRoute(CREATE_FORM), payload);
  // },
  // update_form(payload) {
  //   return Repository.post(transformRoute(UPDATE_FORM), payload);
  // },
  // delete_form(payload) {
  //   return Repository.post(transformRoute(DELETE_FORM), payload);
  // },
};

const transformRoute = (route) => {
  return `/cms${route}`;
};
